
import { useState, useEffect } from 'react';
import Button from '../../../components/base/Button';

export default function PortalPreview() {
  const [verifiedAssets, setVerifiedAssets] = useState(47);

  // Update verified assets count periodically
  useEffect(() => {
    const updateAssets = () => {
      setVerifiedAssets(prev => {
        const change = Math.floor(Math.random() * 3) - 1; // -1, 0, or 1
        return Math.max(42, Math.min(52, prev + change)); // Keep between 42-52
      });
    };

    // Update every 90 seconds
    const interval = setInterval(updateAssets, 90000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-32 relative">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-light tracking-tight mb-6">
            Private Access. <span className="bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent font-medium">Premium Opportunities.</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <p className="text-xl text-gray-300 leading-relaxed">
                Once inside, members can view:
              </p>
              
              <div className="space-y-4">
                {[
                  'Verified AI agencies generating recurring revenue',
                  'SaaS tools and micro-automations with active users',
                  'Partner-ready A.I. service models and frameworks',
                  'Incubator projects accepting co-founders or capital'
                ].map((item, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full mt-3 flex-shrink-0"></div>
                    <p className="text-gray-300">{item}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="pt-6">
              <Button variant="primary" size="lg" className="whitespace-nowrap cursor-pointer">
                👉 Apply for Access (Free)
              </Button>
            </div>
          </div>

          {/* Right - Mock Portal UI */}
          <div className="relative">
            {/* Browser Frame */}
            <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl overflow-hidden">
              {/* Browser Header */}
              <div className="bg-white/5 border-b border-white/10 px-6 py-4 flex items-center space-x-3">
                <div className="flex space-x-2">
                  <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                  <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                  <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                </div>
                <div className="flex-1 bg-white/5 rounded-lg px-4 py-2 text-sm text-gray-400">
                  portal.aiexchange.com
                </div>
              </div>

              {/* Portal Content */}
              <div className="p-6 space-y-6">
                {/* Header */}
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-white">Active Listings</h3>
                  <div className="text-sm text-gray-400">{verifiedAssets} verified assets</div>
                </div>

                {/* Blurred Listings */}
                <div className="space-y-4">
                  {[
                    { title: 'Real Estate AI Marketing Agency', type: 'AI Agency', revenue: '██,███' },
                    { title: 'Legal AI Services Company', type: 'AIaaS', revenue: '██,███' },
                    { title: 'Healthcare AI Automation Agency', type: 'AI Agency', revenue: '██,███' }
                  ].map((listing, index) => (
                    <div key={index} className="bg-white/5 border border-white/10 rounded-xl p-4 relative overflow-hidden">
                      {/* Blur Overlay */}
                      <div className="absolute inset-0 backdrop-blur-sm bg-white/5 flex items-center justify-center">
                        <div className="text-center">
                          <i className="ri-lock-line text-2xl text-yellow-400 mb-2"></i>
                          <p className="text-sm text-gray-400">Login Required</p>
                        </div>
                      </div>
                      
                      {/* Content (blurred) */}
                      <div className="flex items-center justify-between">
                        <div>
                          <h4 className="font-medium text-white">{listing.title}</h4>
                          <p className="text-sm text-gray-400">{listing.type}</p>
                        </div>
                        <div className="text-right">
                          <p className="text-sm text-gray-400">Monthly Revenue</p>
                          <p className="font-mono text-white">${listing.revenue}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Floating Access Badge */}
            <div className="absolute -top-4 -right-4 bg-gradient-to-r from-purple-500 to-cyan-500 rounded-full px-4 py-2 text-sm font-medium text-white shadow-lg">
              Members Only
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
